<div class="infinity-logo-wrapper">
	<img class="infinity-logo" src="assets/images/homescreen/infinity_logo.svg" alt="Infinity Logo">
</div>
<div class="middle-box text-center loginscreen animated fadeInDown">
	<div>
		<div class="wcms-logo-wrapper">
			<img class="wcms-logo" src="assets/images/homescreen/infinity_wcms_logo_signet.svg" alt="WCMS Logo">
		</div>
		<h3>{{ "oPassword.sSet" | translate }}</h3>
		<div *ngIf="OBJ_view.show_form">
			<tig-alert></tig-alert>
			<form class="form-with-bg" [formGroup]="OBJ_form_group" (ngSubmit)="onSubmit()" #OBJ_form="ngForm">
				<div class="form-group" [ngClass]="{ 'has-error': (OBJ_form.submitted || OBJ_form_group.get('password').dirty) && !OBJ_form_group.get('password').valid }">
					<input type="password" class="form-control" name="password" placeholder="{{ 'oPassword.sPlaceholder' | translate }}" #password formControlName="password" />
					<i [ngClass]="(password.type=='password'?'fa fa-eye tig-eye':'fa fa-eye-slash tig-eye')" (click)="showPassword(password)"></i>
					<span class="indicator"></span>
					<div class="list">
						<ul #checks></ul>
					</div>
					<div *ngIf="(OBJ_form.submitted || OBJ_form_group.get('password').dirty) && !OBJ_form_group.get('password').valid">
						<div class="help-block" *ngIf="OBJ_form_group.get('password').hasError('required')">{{ "oPassword.sRequired" | translate }}</div>
						<div class="help-block" *ngIf="OBJ_form_group.get('password').value.length > 0 && OBJ_form_group.get('password').hasError('checkPassword')">{{ "oPassword.sInvalid" | translate }}</div>
					</div>
				</div>
				<div class="form-group" [ngClass]="{ 'has-error': (OBJ_form.submitted || OBJ_form_group.get('password_confirm').touched) && (!OBJ_form_group.get('password_confirm').valid || OBJ_form_group.hasError('matchPassword')) }">
					<input type="password" class="form-control" name="password_confirm" placeholder="{{ 'oPassword.sConfirm' | translate }}" #password_confirm formControlName="password_confirm" />
					<i [ngClass]="(password_confirm.type=='password'?'fa fa-eye tig-eye':'fa fa-eye-slash tig-eye')" (click)="showPassword(password_confirm)"></i>
					<div *ngIf="(OBJ_form.submitted || OBJ_form_group.get('password_confirm').touched) && !OBJ_form_group.get('password_confirm').valid">
						<div class="help-block" *ngIf="OBJ_form_group.get('password_confirm').hasError('required')">{{ "oPassword.sConfirmRequired" | translate }}</div>
					</div>
				</div>
				<div class="alert alert-danger" *ngIf="OBJ_form_group.hasError('matchPassword') && OBJ_form_group.get('password_confirm').touched">{{ "oPassword.sNotMatch" | translate }}</div>
				<button [disabled]="BOO_loading" type="submit" class="btn btn-primary block full-width m-b">{{ "oPassword.sSet" | translate }}</button>
				<img *ngIf="BOO_loading" src="assets/images/loading.gif" />
				<p class="text-muted text-center"><small>{{ "oAccount.sHave" | translate }}</small></p>
				<button type="button" class="btn btn-sm btn-white btn-block" [routerLink]="['/login']">{{ "oLogin.sPlaceholder" | translate }}</button>
			</form>
		</div>
		<div [ngClass]="{ 'has-error': OBJ_view.error }" *ngIf="!OBJ_view.show_form">
			<div [ngClass]="{ 'help-block': OBJ_view.error }">{{ OBJ_view.message | translate }}</div>
			<button type="button" class="btn btn-sm btn-primary btn-block m-t btn-wcms-home" [routerLink]="['/login']">{{ "oLogin.sPlaceholder" | translate }}</button>
		</div>
		<p class="m-t"><small>{{ STR_company }}</small></p>
	</div>
</div>
